<style lang="scss" scoped>
.header {
	&__block {
		border-bottom: 1px solid #edeff0;
		background: white;
	}
	&__container {
		@include container;
		@include flex-center;
		height: 80px;
	}
	&__breadcrumb {
		@include container;
		@include flex-center;
		height: 70px;
		font-weight: 700;
		&:empty {
			display: none;
		}
		& /deep/ * {
			font-weight: 700;
		}
	}
	&__title {
		height: 40px;
		cursor: pointer;
	}
	&__text {
		cursor: pointer;
		font-size: 1.1rem;
		margin-left: 30px;
		font-weight: 600;
	}
	&__return {
		margin-left: auto;
		&__icon {
			position: relative;
			top: 5px;
			margin-right: 5px;
		}
		&__link {
			font-weight: 600;
		}
	}
	&__menu {
		margin-left: auto;
		// border-bottom: 0 !important;
		// margin-right: 60px;
	}
	& /deep/ .el-submenu__title,
	& /deep/ .el-menu-item {
		height: 80px;
		line-height: 80px;
		font-size: 16px;
	}
	& /deep/ .el-menu-item.is-active {
		font-weight: bold;
	}
}
</style>

<template lang="pug">
    .header
        .header__block
            .header__container
                img(src="@/assets/Wonde-Icon-Colour.svg", @click="goHome()").header__title
                .header__text(@click="goHome()").hidden-sm-and-down Discover
                .header__return
                    a(href="https://edu.wonde.com").header__return
                        arrow-left-icon.header__return__icon(size='1.3x')
                        span.header__return__link Return to Dashboard
        .header__block
            .header__breadcrumb
                slot(name="breadcrumb")
</template>

<script>
import { ArrowLeftIcon } from "vue-feather-icons";

export default {
	components: {
		ArrowLeftIcon
	},
	methods: {
		goHome() {
			this.$router.push({ name: "homepage" });
		},
		goLogin() {
			location.href = `${process.env.VUE_APP_EDU_WONDE_DOMAIN}login`;
		},
		goSignUp() {
			location.href = `${process.env.VUE_APP_WONDE_DOMAIN}sign-up/sso`;
		}
	}
};
</script>

